import React, {Component} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import MediaQuery from 'react-responsive';
import SwitchWalletRight from './switchWalletRight.jsx'
import { numberWithCommas } from '../../fiches';

import icon_CPT from '../../images/icon_cpt.png'
import icon_ETH from '../../images/icon_eth.png'
import icon_XEM from '../../images/icon_xem.png'
import icon_PROOF from '../../images/icon_pf.png'
import icon_XYO from '../../images/icon_xyo.png'
import icon_K2G from '../../images/icon_k2g.png'

export default class switchWallet extends Component {
    constructor(props) {
        super(props)

        this.iconsWallets = {
            CPT: icon_CPT,
            XEM: icon_XEM,
            ETH: icon_ETH,
            PROOF: icon_PROOF,
            XYO: icon_XYO,
            K2G: icon_K2G,
            K2G_C: icon_K2G,
        };

        this.total = 0;
        this.translation = JSON.parse(localStorage.translation)[localStorage.language];
    }

    countTotal = () => {
        let wallets = this.props.data.wallets, total = 0;
        wallets.map((item) => {total += +item.usd;});
        this.total = total;
    }

    render() {
        this.countTotal();

        const headersSwitchWallet = this.props.data.wallets.map((item, i) => {

            const switchWalletTabStyle = ['switchWallet_tab']

            if (this.props.tabState.openBlockId === i) {
                switchWalletTabStyle.push('click')
            }

            return (
                <MediaQuery key = {i} query="(min-width: 50em)">
                    {matches => {
                        return matches
                            ?   <div key={i} className={switchWalletTabStyle.join('--')} onClick={() => {this.props.switchTab(item.currency, i, item.blockchain)}}>
                                    <div className="switchWallet_tab_cryptocurrency-icon">
                                        {this.iconsWallets[item.currency] ? (<img src={this.iconsWallets[item.currency]}></img>) : ''}
                                    </div>
                                    <div className="switchWallet_tab_cryptocurrency-name">
                                        <p>{item.currency}</p>
                                    </div>
                                    <div className="switchWallet_tab_cryptocurrency-balance">
                                        <p>{numberWithCommas(item.balance)}</p>
                                    </div>
                                    <div className="switchWallet_tab_cryptocurrency-balance-USD">
                                        <p>{numberWithCommas(Number(item.usd).toFixed(2))} $</p>
                                    </div>
                                    <div className="switchWallet_tab_icon">
                                        <FontAwesomeIcon icon={'angle-right'}/>
                                    </div>
                                </div>
                            :   <div key={i} className={switchWalletTabStyle.join('--')} >
                                    <div className="switchWallet_tab_nav" onClick={() => {this.props.switchTab(item.currency, i, item.blockchain)}}>
                                        <div className="switchWallet_tab_cryptocurrency-icon">
                                            {this.iconsWallets[item.currency] ? (<img src={this.iconsWallets[item.currency]}></img>) : ''}
                                        </div>
                                        <div className="switchWallet_tab_cryptocurrency-name">
                                            <p>{item.currency}</p>
                                        </div>
                                        <div className="switchWallet_tab_cryptocurrency-balance">
                                            <p>{numberWithCommas(item.balance)}</p>
                                        </div>
                                        <div className="switchWallet_tab_cryptocurrency-balance-USD">
                                            <p>{numberWithCommas(Number(item.usd).toFixed(2))} $</p>
                                        </div>
                                        <div className="switchWallet_tab_icon">
                                            <FontAwesomeIcon icon={'angle-right'}/>
                                        </div>
                                    </div>
                                    {this.props.tabState.openBlockId === i ?
                                        <SwitchWalletRight
                                            exitOverdueSession = {this.props.exitOverdueSession}
                                            activeTab = {this.props.tabState.activeTab}
                                            currentWallet = {this.props.currentWallet}
                                            data = {this.props.data}
                                        />
                                        : null}
                                </div>
                    }}
                </MediaQuery>
            )
        })

        return (
            <div className="switchWallet">
                {headersSwitchWallet}
                <div className="switchWallet_tab">
                    <div className="switchWallet_tab_total_info">
                        <span>{this.translation['Total']}: </span>
                    </div>
                    <div className="switchWallet_tab_total_balance">
                        <p>{numberWithCommas(Number(this.total).toFixed(2))} $</p>
                    </div>
                </div>
            </div>
        )
    }
}
